import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Sub-component для RootLayout — сбрасывает скролл всех `.overflow-y-auto`
 * контейнеров + window при смене pathname. Реализация P-047.
 *
 * Почему НЕ React Router v7 `<ScrollRestoration />`: built-in component работает
 * только с window scroll. В этом приложении scroll живёт на inner
 * `.overflow-y-auto` div'е внутри layout shell (P-046):
 * ```
 * <main className="min-h-screen flex flex-col bg-canvas">
 *   <Header />
 *   <section className="flex-1 overflow-y-auto">{content}</section>  ← scroll
 *   <BottomBar />
 * </main>
 * ```
 * Body не скроллится — `<ScrollRestoration />` поэтому не помогает.
 *
 * Side effects: при route change query selector обходит все scroll containers
 * на странице. Затраты ничтожны (1-2 элемента в DOM в любой момент), runs once
 * per navigation. `behavior: 'instant'` — пользователь ожидает мгновенный
 * сброс при переходе, animated scroll сбивает контекст.
 */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const containers = document.querySelectorAll<HTMLElement>('.overflow-y-auto');
    containers.forEach((el) => {
      el.scrollTop = 0;
    });
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);

  return null;
}
